/**
 * React Query cache namespace and progress-toast id prefix for this surface. Mirrors
 * `BuildingAttachments/constants.ts` — the shared surface, the field commit and the bulk actions
 * all have to agree on the entity key.
 */
export const INSPECTION_ATTACHMENTS_ENTITY_KEY = 'inspection-attachments';
/** Locale namespace holding this surface's table copy. */
export const INSPECTION_ATTACHMENTS_NS = 'features.inspection_attachments.table';
export const MASS_ACTIONS_NS = 'features.inspection_attachments.mass_actions';
/**
 * Note `tab`, not `table` — a sibling of the table namespace, not a child. Deriving it as
 * `${namespace}.progress_toast` is what produced a `[missing ...]` string on the Building surface
 * that a green test suite could not see (task-05), which is why the shared config takes it
 * explicitly rather than computing it.
 */
export const PROGRESS_TOAST_NS = 'features.inspection_attachments.tab.progress_toast';
export const EDIT_MODAL_ERRORS_NS = 'features.inspection_attachments.edit_modal.errors';
export const UPLOAD_NS = 'features.inspection_attachments.upload';
export const COMMONS_NS = 'features.commons';
/** `answer` enum values, matching InspectionAttachment's Rails enum. */
export const RESULT_PASS = 'pass';
export const RESULT_FAIL = 'fail';
/** Filter/select identity for a row whose `answer` is NULL — the enum has no such member. */
export const RESULT_NONE = 'none';
/** Report-option filter identities. */
export const REPORT_OPTION_SUMMARY = 'show_on_report';
export const REPORT_OPTION_COVER_LETTER = 'include_in_cover_letter';
/** Finalize attribute names — the wire shape the inspection presign/finalize endpoints accept. */
export const ATTR_SHOW_ON_REPORT = 'show_on_report';
export const ATTR_INCLUDE_IN_COVER_LETTER = 'include_in_cover_letter';
export const ATTR_ANSWER = 'answer';
export const ATTR_TECHNICIAN_NAME = 'technician_name';
export const ATTR_CERTIFICATION_NUMBER = 'certification_number';
/** The registry caps this surface at PDFs (DirectUploads::AttachmentType::PDF_ONLY). */
export const INSPECTION_ACCEPT = 'application/pdf';
